module.exports = __webpack_public_path__ + "static/fonts/Fact-NarrowThin.c4b6dcb.eot";